import { createClient } from '@supabase/supabase-js'
export const supabase = createClient(
  'https://cgnvcxfavflqvxbtdvxw.supabase.co',
  'sb_publishable_QcibLUIx6BwhxwIlQ5mEGw_K2LMOok6'
)
